import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';

import { MonetizationType } from '@/@types/graphql-types';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'Buy',
  props: {
    title: null,
    offers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
};

const { language } = useLanguageStore();



const { getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock } = useSpinningText(toRefs(props));

const text = computed(() => {
	switch (language.value) {
		case 'fi':
			return getInfoTextBlock(MonetizationType.Buy, 'Voit ostaa elokuvan', 'digitaalisena versiona palvelussa');
		case 'ru':
			return getInfoTextBlock(MonetizationType.Buy, 'Вы можете купить и скачать', 'на');
		case 'it':
			return getInfoTextBlock(MonetizationType.Buy, 'Puoi acquistare', 'scaricandolo da');
		case 'de':
			return getInfoTextBlock(MonetizationType.Buy, 'Du kannst', 'bei', 'online als Download kaufen');
		case 'pt':
			return getInfoTextBlock(MonetizationType.Buy, 'Você pode assistir', 'no', 'para fazer o download online');
		case 'fr':
			return getInfoTextBlock(MonetizationType.Buy, 'Vous pouvez acheter', 'sur', 'en téléchargement');
		case 'es':
			return getInfoTextBlock(MonetizationType.Buy, 'Actualmente, usted es capaz de comprarlo', 'en', 'online');
		case 'ja':
			return getInfoTextBlock(MonetizationType.Buy, 'は', 'で配信版を購入してダウンロードすることができます');
		case 'ko':
			return getOfferTextBlock(
				MonetizationType.Buy,
				'현재 ',
				`에서 "${props.title}"의 영상을 유료 다운로드하실 수 있습니다`
			);
		case 'ro':
			return getInfoTextBlock(MonetizationType.Buy, 'Puteți să cumpărați', 'pe', 'prin descărcare');
		case 'hu':
			return getInfoTextBlock(
				MonetizationType.Buy,
				'A(z)',
				'megvásárolható a(z)',
				'szolgáltatónál letöltésként.'
			);
		case 'cs':
			return getInfoTextBlock(MonetizationType.Buy, 'Si můžete koupi', 'u', 'ke stažení');
		case 'bg':
			return getInfoTextBlock(MonetizationType.Buy, 'Можете да купите', 'в', 'като изтеглена версия');
		case 'ar':
			return getInfoTextBlock(MonetizationType.Buy, 'يمكنكم شراء', 'عبر', 'وتنزيله');
		case 'pt':
			return getInfoTextBlock(MonetizationType.Buy, 'Você pode comprar', 'via', 'como download');
		case 'tr':
			return getInfoTextBlock(MonetizationType.Buy, '', 'adlı yapımı', 'üzerinden satın alarak indirebilirsiniz');
		case 'sq':
			return getInfoTextBlock(MonetizationType.Buy, 'Ju mund ta blini', 'në', 'si shkarkim');
		case 'pl':
			return getInfoTextBlock(MonetizationType.Buy, 'Możesz kupić', 'w serwisie', 'jako plik do pobrania');
		case 'ro':
			return getInfoTextBlock(MonetizationType.Buy, 'Poți să cumperi și să descarci', 'pe');
		case 'az':
			return getInfoTextBlock(MonetizationType.Buy, 'Siz', 'filmini', 'vasitəsilə alaraq endirə bilərsiniz');
		case 'el':
			return getInfoTextBlock(MonetizationType.Buy, 'Μπορείτε να αγοράσετε τον τίτλο', 'στο', 'ως αρχείο λήψης');
		case 'sr':
			return getInfoTextBlock(MonetizationType.Buy, 'Možete da kupite', 'na', 'kao preuzimanje');
		case 'ja':
			return getInfoTextBlock(MonetizationType.Buy, '', 'は', 'からダウンロードして購入できます');
		case 'sv':
			return getInfoTextBlock(MonetizationType.Buy, 'Du kan köpa', 'på', 'som nedladdning');
		case 'uk':
			return getInfoTextBlock(MonetizationType.Buy, 'Ви можете придбати і завантажити', 'на');
		case 'ur':
			return getRTLInfoTextBlock(MonetizationType.Buy, 'آپ ڈاؤن لوڈ کے طور پر', 'پر', 'خریدنے کے قابل ہیں۔');
		case 'en':
		default:
			return getInfoTextBlock(MonetizationType.Buy, 'You are able to buy', 'on', 'as download');
	}
});

return { __sfc: true,language, props, getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock, text }
}

})